import tripEvents from '../config/events.constant';
import template from './trip-approval.html';
import * as angular from 'angular';

const DIRECTIVE_NAME = TripCheckoutApproval.DIRECTIVE_NAME = 'ktTripCheckoutApproval';
export default function TripCheckoutApproval() {
    return {
        restrict: 'A',
        bindToController: true,
        scope: {
            approvalModel: `=${DIRECTIVE_NAME}`,
            checkoutForm: `=${DIRECTIVE_NAME}CheckoutForm`,
            isBook: `=${DIRECTIVE_NAME}IsBook`,
            actionData: `=${DIRECTIVE_NAME}ActionData`,
            tripData: `=${DIRECTIVE_NAME}TripData`,
            tripDetails: `=${DIRECTIVE_NAME}TripDetails`,
        },
        template,
        controller: TripCheckoutApprovalController,
        controllerAs: '$ctrl',
        link: ($scope, $elem, $attrs, $ctrl) => $ctrl.$onInit(),
    };
}

export function TripCheckoutApprovalController(
    $scope,
    $rootScope,
    l10nService,
    userService,
    tripAPI,
    tripApprovalService
) {
    'ngInject';

    const vm = this;
    let bankHolidays;

    const {
        dateFormat,
        timeFormat,
        ISO,
        gmtOffset,
    } = userService.getRegionalSettings();

    Object.assign(vm, {
        $onInit,
        localize: l10nService.localize,
        searchApprovers,
        uniteApproverNames,
        onApproverSelect,
        clearApprover,
        disableSearch,
    });

    function $onInit() {
        tripApprovalService.fetchBankHolidays()
            .then((days) => bankHolidays = days);

        initDatepickerSettings();
        initWatchers();
        vm.approver = getApprover();
        vm.dropdownIdApprover = null;
        vm.approvers = null;
        vm.dropdownSelectValue = null;
        subscribe();
        init();
        initActionData();
        vm.hasApprovers = false;
        vm.approverOverrideSelectedValue = null;
    }

    function searchApprovers(value) {
        if (vm.approvers !== null && angular.isDefined(vm.approvers[vm.dropdownSelectValue])) {
            return vm.approvers[vm.dropdownSelectValue];
        }
        return tripAPI.searchApprovers(value, vm.approvalModel.ApprovalLevel);
    }

    function onApproverSelect() {
        vm.approvalModel.ApproverId = vm.approver.ContactId;
    }

    function subscribe() {
        $scope.$on(tripEvents.TRIP_REFRESH_CHECKOUT_FORM_STATE, init);
        $scope.$on(tripEvents.CLEAR_APPROVER, function(event, data) {
            clearApprover(data);
        });
        $rootScope.$on(tripEvents.PROCESS_STATIC_APPROVERS, function(event, obj) {
            vm.approvers = obj.data;
            $rootScope.approvers = obj.data;
            $rootScope.approversPaymentCodeId = obj.paymentCodeId;
            vm.dropdownIdApprover = obj.paymentCodeId;
            $scope.hasApprovers = true;
        });
        $scope.$on(tripEvents.WIPE_APPROVER, function() {
            vm.approver = null;
        });
    }

    function getApprover() {
        const appSettings = vm.tripData.ApprovalSettings;
        return appSettings.IsAutomatedProcess
            ? null
            : vm.tripDetails.LastApprover;
    }

    function uniteApproverNames(approver) {
        return approver ? `${approver.FullName} (${approver.Email})` : false;
    }

    function initDatepickerSettings() {
        const appSettings = vm.tripData.ApprovalSettings;
        const availableApprovalDate = {
            start: function() {
                const currentDate = moment();
                const todayIsMaxApprovalDate = moment(appSettings.MaximumApprovalDate).isSame(currentDate, 'd');
                const currentMonthEnd = moment(currentDate).endOf('month');
                const todayIsEndOfMonth = moment(currentMonthEnd).isSame(currentDate, 'd');

                return (todayIsEndOfMonth && !todayIsMaxApprovalDate) ? currentDate.add({days: 1}) : currentDate;
            },

            after: function() {
                const userTimeOffset = moment().utcOffset() / 60;
                const currentDate = moment.utc().add({hours: gmtOffset});
                const maxApprovalDate = moment(appSettings.MaximumApprovalDate)
                    .utc(userTimeOffset)
                    .add({hours: gmtOffset});
                const isToday = moment(appSettings.MaximumApprovalDate)
                    .startOf('day')
                    .isSame(moment().startOf('day'));

                return (maxApprovalDate.isBefore(currentDate) && isToday)
                    ? currentDate
                    : currentDate.subtract({days: 1});
            },

            before: function() {
                const maxApprovalDate = moment(appSettings.MaximumApprovalDate).utc();
                const maxApprovalDateMinutes = moment.duration(appSettings.MaximumApprovalDate).asMinutes();

                return (maxApprovalDateMinutes < appSettings.MinimumApprovalTime)
                    ? maxApprovalDate.subtract({days: 1})
                    : maxApprovalDate;
            },
        };

        vm.datepickerSettings = {
            placeholder: l10nService.localize('Choose Date'),
            required: true,
            months: 2,
            start: availableApprovalDate.start(),
            after: availableApprovalDate.after(),
            before: availableApprovalDate.before(),
            dateFormat,
            filter: function(day) {
                const holiday = _.some(bankHolidays, function(bankHoliday) {
                    return day.format(dateFormat) === moment(bankHoliday).format(dateFormat);
                });

                /**
                 * false - disable
                 * true - enable
                 */
                return !holiday;
            },
        };
    }

    function initWatchers() {
        $scope.$watch(() => vm.approvalModel, function(approvalModel, oldApprovalModel) {
            if (vm.showApproval && approvalModel.date && approvalModel.date !== oldApprovalModel.date) {
                vm.timeOptions = createTimeOptions(approvalModel.date);
                vm.approvalModel.time = angular.copy(vm.timeOptions[vm.timeOptions.length - 1]);
            }
        }, true);
    }

    function initActionData() {
        vm.actionData.getApprovalData = function() {
            if (vm.showApproval) {
                return {
                    ApproverId: vm.approvalModel.ApproverId || null,
                    ApprovalDateTime: makeFullApprovalDate(),
                    Comment: vm.approvalModel.comment || null,
                    ApprovalLevel: vm.approvalModel.ApprovalLevel,
                };
            }

            return null;
        };

        vm.actionData.getPolicyReason = function() {
            return vm.approvalModel.policyReason.value || null;
        };

        vm.actionData.getFareReason = function() {
            return vm.approvalModel.fareReason.value || null;
        };
    }

    function init() {
        const appSettings = vm.tripData.ApprovalSettings;
        initDatepickerSettings();
        vm.fareOptions = convertOptions(vm.tripData.LowestFareReasons);
        vm.policyOptions = convertOptions(vm.tripData.OutOfPolicyReasons);

        if (appSettings) {
            //If approval process is required -and- not started yet
            vm.showApproval = !vm.tripData.IsApproved && vm.isBook && appSettings.IsApprovalRequired;
        }

        vm.outOfPolicyReasons = vm.tripData.OutOfPolicyReasons;
        vm.lowestFareReasons = vm.tripData.LowestFareReasons;

        // TODO: Potential issue since no arguments provided
        const selectedDate = getSelectedDate();
        vm.timeOptions = createTimeOptions(selectedDate);

        if (!vm.approvalModel) {
            applyDefaultsToModel();
        }
        if (vm.showApproval) {
            $rootScope.$broadcast(tripEvents.SET_STATIC_APPROVERS);
        }
    }

    function getSelectedDate() {
        return vm.approvalModel && vm.approvalModel.date || undefined;
    }

    function applyDefaultsToModel() {
        const isAutomatedProcess = vm.tripData.ApprovalSettings.IsAutomatedProcess;
        const lastApprover = vm.tripDetails.LastApprover;
        const approverId = !isAutomatedProcess && lastApprover && lastApprover.ContactId || null;

        vm.approvalModel = {
            fareReason: getReasonById(vm.fareOptions, vm.tripDetails.LowestFareReasonCodeId),
            policyReason: getReasonById(vm.policyOptions, vm.tripDetails.OutOfPolicyReasonCodeId),
            comment: '',
            ApproverId: approverId,
            time: {},
            date: null,
            ApprovalLevel: vm.tripData.ApprovalSettings.ApprovalLevel,
        };
    }
    function createTimeOptions(selectedApprovalDate) {
        const appSettings = vm.tripData.ApprovalSettings;
        const options = [];
        let title = '';
        const {
            MinimumApprovalTime,  // minutes from day start
            MaximumApprovalTime,
            MaximumApprovalDate,
            ApprovalTimeInterval,
        } = appSettings;

        let startTime = MinimumApprovalTime;
        let endTime = MaximumApprovalTime;
        const stepTime = ApprovalTimeInterval;
        const today = moment().startOf('day');
        const lastDay = moment(MaximumApprovalDate).startOf('day');
        const isToday = moment(selectedApprovalDate, dateFormat).isSame(today);
        const isLastDay = moment(selectedApprovalDate, dateFormat).isSame(lastDay);
        const startOfDay = moment().startOf('day');

        if (isToday) {
            const minutesToAdd = stepTime - moment().minute() % stepTime;
            startTime = Math.abs(startOfDay.diff(moment().add('minutes', minutesToAdd), 'minutes'));
        }

        if (isLastDay) {
            const maxApprovalDate = moment(MaximumApprovalDate);
            const minutesFromLastDayStart = maxApprovalDate.hours() * 60 + maxApprovalDate.minutes();
            const maximumApprovalTime = parseInt(minutesFromLastDayStart / stepTime, 10) * stepTime;

            endTime = _.min([maximumApprovalTime, endTime]);
        }

        while (startTime <= endTime) {

            title = moment().startOf('day').add({minutes: startTime}).format(timeFormat);

            options.push({
                text: title,
                value: startTime,
            });
            startTime += stepTime;
        }
        return options;
    }

    function makeFullApprovalDate() {
        const {date: approvalDate, time} = vm.approvalModel;
        const approvalTime = time.value;

        return approvalDate
            ? moment(approvalDate, dateFormat)
                .add({minutes: approvalTime})
                .format(ISO)
            : null;
    }

    function convertOptions(data) {
        return _.map(_.pairs(data), function(option) {
            return {
                text: option[1],
                value: option[0],
            };
        });
    }

    function getReasonById(reasons, reasonId) {
        return _.findWhere(reasons, {value: (+reasonId).toString()}) || {};
    }

    function clearApprover(obj) {
        vm.approver = null;
        if (vm.approvers !== null && obj.dropdownId === vm.dropdownIdApprover) {
            vm.dropdownSelectValue = obj.item.value;
        } else if (obj.dropdownId === vm.dropdownIdApprover) {
            vm.dropdownSelectValue = null;
        }
    }

    function disableSearch(valid) {
        if (angular.isUndefined(valid)) {
            return false;
        } else if (angular.isDefined(valid) && !valid) {
            return true;
        } else if (angular.isDefined(valid) && valid) {
            return false;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/trip-approval/trip-approval-component.js